document.querySelectorAll('.shopify_subscriptions_fieldset input[type=radio]').forEach(radio => {
radio.addEventListener('change', function() {
// Reset the border of all ul and wrapper elements
document.querySelectorAll('.shopify_subscriptions_app_block_label_children, .shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper, .shopify_subscriptions_app_block_label:nth-of-type(2)').forEach(element => {
element.style.border = '';
});

// Add a border to the specific parent .shopify_subscriptions_app_block_label:nth-of-type(2) if the related radio button is checked
if (radio.checked && radio.getAttribute('aria-label').includes('Delivery')) {
let parentLabel = document.querySelector('.shopify_subscriptions_app_block_label:nth-of-type(2)');
if (parentLabel) {
parentLabel.style.setProperty('border', '1px solid #FF6700', 'important');
}
}

// Add a border to the specific parent wrapper if the related radio button is checked
if (radio.checked && radio.getAttribute('aria-label').includes('One-time purchase')) {
let parentWrapper = radio.closest('.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper');
if (parentWrapper) {
parentWrapper.style.setProperty('border', '1px solid #FF6700', 'important');
}
}
});
});

// Toggle the bundle-save presets based on the selected purchase option (scoped to the subscription widget)
function updateDivClass() {
const div = document.querySelector('.cus-bundle-save');
if (!div) return;
document.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"]').forEach(radio => {
const label = radio.getAttribute('aria-label') || '';
if (radio.checked && label.includes('Delivery')) {
div.classList.add('bundle-none');
div.classList.remove('bundle-flex');
} else if (radio.checked && label.includes('One-time purchase')) {
div.classList.add('bundle-flex');
div.classList.remove('bundle-none');
}
});
}

document.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"]').forEach(radio => {
radio.addEventListener('change', updateDivClass);
});

// Ensure ONE-TIME PURCHASE is the effective default after the Subscriptions app JS runs.
// The app block re-selects the subscription post-load; this reverts it unless the shopper
// has interacted with the widget. Stops after first interaction or 3 seconds.
(function () {
var interacted = false;
document.addEventListener('pointerdown', function (e) {
if (e.target.closest('.shopify_subscriptions_app_container, .shopify_subscriptions_fieldset')) {
interacted = true;
}
}, true);

var tries = 0;
var timer = setInterval(function () {
tries++;
if (interacted || tries > 15) { clearInterval(timer); return; }
var radios = document.querySelectorAll('.shopify_subscriptions_fieldset input[type=radio]');
if (!radios.length) return;
var oneTime = null;
var subChecked = false;
radios.forEach(function (r) {
var label = r.getAttribute('aria-label') || '';
if (label.indexOf('One-time') > -1) { oneTime = r; }
else if (r.checked) { subChecked = true; }
});
if (subChecked && oneTime && !oneTime.checked) {
oneTime.click();
}
}, 200);
})();

// The Shopify Subscriptions app injects the selling-plan price into .in_widget_price as
// ESCAPED HTML text (the literal string "<span class=money>$X USD</span>") because this
// theme's money format includes markup. Now that we show those price elements (CSS un-hide
// in the @app block), the raw tags render as visible text. Convert them back to real DOM.
// Idempotent: once fixed the element has a child node and no "<span" in text, so it is skipped.
(function () {
function fixPrices(root) {
(root || document).querySelectorAll('.shopify_subscriptions_fieldset .in_widget_price').forEach(function (el) {
if (el.children.length === 0 && el.textContent.indexOf('<span') > -1) {
el.innerHTML = el.textContent;
}
});
}
fixPrices(document);
var container = document.querySelector('.shopify_subscriptions_app_container');
if (container && window.MutationObserver) {
new MutationObserver(function () { fixPrices(container); })
.observe(container, { childList: true, subtree: true, characterData: true });
}
// Safety re-runs in case the app renders the widget after first paint.
var n = 0, t = setInterval(function () { n++; if (n > 15) { clearInterval(t); return; } fixPrices(document); }, 200);
})();
